<template>
  <div class="studentAchievement">
    <header>
      <div>
        <div class="main-title">
          <h3>{{ cupName }}</h3>
        </div>
        <div class="otherSeason" @click="toRests">
          历史赛季
          <van-icon name="arrow" />
          <!-- <slideDownSelect
            @change="seasonChange"
            :isSeason="true"
            :title="currentSeasonLabel"
            :slideData="otherSeasonData"
            :widthSty="true"
          /> -->
        </div>
      </div>
      <div class="inputBoxWrapper">
        <InputBox
          borderRadius="43px"
          width="70%"
          @doSearch="doSearch"
          @inputBlur="getUserName"
        />
        <router-link
          :style="{ visibility: !isTrainingGrounds ? 'visible' : 'hidden' }"
          :to="{
            name: 'honorRoll',
            params: {
              scheduleId: currentSeason.scheduleId,
              seasonId: currentSeason.seasonId,
              currentSeason,
            },
          }"
          class="honorRoll"
          >升段光荣榜></router-link
        >
      </div>
      <div>
        <label @click="handleDateSelection">
          <template v-if="!isTrainingGrounds">
            <span
              >时间段选择 {{ startDateLabel ? startDateLabel + "~" : ""
              }}{{ endDateLabel }}</span
            >
          </template>
          <template v-else>
            <template v-if="isSelectDate">
              <span
                >时间段选择 {{ startDateLabel ? startDateLabel + "~" : ""
                }}{{ endDateLabel }}</span
              >
            </template>
            <template v-else> 近7天 </template>
          </template>
          <img
            class="calendar"
            src="../../../src/assets/images/winterGame/calendarGrayIcon.png"
            alt="calendar"
          />
        </label>

        <slideDownSelect
          @change="subjectChange"
          :title="currentSubject"
          :slideData="subjectData"
        />
      </div>
    </header>
    <section>
      <div class="list" v-if="filterList.length > 0 && !loading">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="item" v-for="(item, index) in filterList">
            <div class="title">
              <h3>{{ item.real_name }}</h3>
              {{ item.uname }}
              <!-- <router-link
                v-if="!isTrainingGrounds"
                class="more"
                :to="{
                  name: 'memberDetail',
                  params: {
                    accountId: item.account_id,
                    subject: currentSubject,
                    cupName: currentSeason.name,
                    scheduleId: currentSeason.scheduleId || 0,
                    seasonId: currentSeason.seasonId,
                    currentSeason,
                  },
                }"
                >查看详情></router-link
              > -->
              <a v-if="!isTrainingGrounds"  @click="viewMemberDetail(item)" class="more">查看详情</a>
            </div>
            <main>
              <table v-if="!isTrainingGrounds">
                <tr>
                  <td>
                    <div>
                      <dl>
                        <dt>排名</dt>
                        <dd>{{ item.season_rank }}</dd>
                      </dl>
                      <dl>
                        <dt>段位</dt>
                        <dd>
                          {{ item.segment_name
                          }}<template v-if="item.segment_id < 42"
                            >{{ item.segment_level }}级</template
                          >
                        </dd>
                      </dl>
                      <dl>
                        <dt>奖杯数</dt>
                        <dd>{{ item.pk_score | formatNumberFilter }}</dd>
                      </dl>
                    </div>
                  </td>
                  <!-- <td>
                    <div>
                      <dl>
                        <dt>PK天数</dt>
                        <dd>{{ item.pk_day_count | formatNumberFilter }}</dd>
                      </dl>
                      <dl>
                        <dt>奖杯数</dt>
                        <dd>{{ item.pk_score | formatNumberFilter }}</dd>
                      </dl>
                    </div>
                  </td> -->
                </tr>
                <tr v-if="item.isShowAll">
                  <td>
                    <div>
                      <dl>
                        <dt>局数</dt>
                        <dd>{{ item.pk_count | formatNumberFilter }}</dd>
                      </dl>
                      <dl>
                        <dt class="textSty">胜/负/平/空/单</dt>
                        <!-- <dd>
                          {{ item.win_count | formatNumberFilter }}/{{
                            item.fail_count | formatNumberFilter
                          }}/{{ item.flat_count | formatNumberFilter }}/{{
                            item.empty_count | formatNumberFilter
                          }}
                        </dd> -->
                        <!-- TODO 单人比赛的字段 <dt>胜/负/平/空/单</dt> -->
                        <dd>
                          {{ item.win_count | formatNumberFilter }}/{{
                            item.fail_count | formatNumberFilter
                          }}/{{ item.flat_count | formatNumberFilter }}/{{
                            item.empty_count | formatNumberFilter
                          }}/{{ item.single_count | formatNumberFilter }}
                        </dd>
                      </dl>
                      <dl>
                        <dt>PK天数</dt>
                        <dd>{{ item.pk_day_count | formatNumberFilter }}</dd>
                      </dl>
                    </div>
                  </td>
                </tr>
                <tr v-if="item.isShowAll">
                  <td>
                    <div>
                      <dl>
                        <dt>胜率</dt>
                        <dd>{{ Math.round(item.pk_rate / 100) }}%</dd>
                      </dl>
                      <dl>
                        <dt>局均奖杯数</dt>
                        <dd>{{ item.average_score | formatNumberFilter }}</dd>
                      </dl>
                      <dl>
                        <dt></dt>
                        <dd></dd>
                      </dl>
                    </div>
                  </td>
                </tr>
              </table>
              <!-- 训练场的逻辑不变 -->
              <div class="trainingGrounds" v-else>
                <div v-if="item.auto">
                  <span>自动匹配 </span>
                  <div>
                    <dl>
                      <dt>局数</dt>
                      <dd>
                        {{ item.auto?.pk_count }}
                      </dd>
                    </dl>
                    <dl>
                      <dt>奖杯数</dt>
                      <dd>
                        {{ item.auto.score }}
                      </dd>
                    </dl>
                    <dl>
                      <dt>胜/负/平/空</dt>
                      <dd>
                        {{ item.auto.win_count | formatNumberFilter }}/{{
                          item.auto.fail_count | formatNumberFilter
                        }}/{{ item.auto.flat_count | formatNumberFilter }}/{{
                          item.auto.empty_count | formatNumberFilter
                        }}
                      </dd>
                    </dl>
                  </div>
                </div>
                <div v-if="item.isShowAll && item.face_to_face">
                  <span>面对面</span>
                  <div>
                    <dl>
                      <dt>局数</dt>
                      <dd>
                        {{ item.face_to_face?.pk_count }}
                      </dd>
                    </dl>
                    <dl>
                      <dt>奖杯数</dt>
                      <dd>
                        {{ item.face_to_face.score }}
                      </dd>
                    </dl>
                    <dl>
                      <dt>胜/负/平/空</dt>
                      <dd>
                        {{
                          item.face_to_face.win_count | formatNumberFilter
                        }}/{{
                          item.face_to_face.fail_count | formatNumberFilter
                        }}/{{
                          item.face_to_face.flat_count | formatNumberFilter
                        }}/{{
                          item.face_to_face.empty_count | formatNumberFilter
                        }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
            </main>
            <div
              class="arrow"
              :class="[isTrainingGrounds ? 'trainingGroundsArr' : '']"
              @click="showInfo(index)"
            >
              <arrow :rotateDeg="item.rotateDeg" />
            </div>
          </div>
        </van-list>
      </div>
      <div class="emptyData" v-else-if="filterList.length == 0 && !loading">
        <emptyData />
      </div>
      <div class="loading-container" v-else-if="loading">
        <van-loading type="spinner" color="#58abf6" />
      </div>
    </section>
    <div class="calendar">
      <van-calendar
        type="range"
        :default-date="defaultDate"
        :min-date="minDate"
        :max-date="maxDate"
        v-model="isCalendarShow"
        @confirm="onConfirm"
        :allow-same-day="true"
      />
    </div>
  </div>
</template>

<script>
import arrow from "./components/arrow.vue";
import emptyData from "./components/emptyData.vue";
import slideDownSelect from "./components/slideDownSelect.vue";
import InputBox from "./components/inputBox.vue";
import {
  queryhistorycupv3,
  queryMembers,
  getTrainingData,
} from "../../api/winterGame";
import {
  formatDate,
  formatMonthDate,
} from "@/util/util";
import { Toast } from "vant";

export default {
  computed: {},
  components: {
    InputBox,
    arrow,
    emptyData,
    slideDownSelect,
  },
  data() {
    return {
      loading: false,
      finished: false,
      isTrainingGrounds: false, //是否是训练场
      isSelectDate: false, // 是否选择了日期组件上的日期
      currentSeason: "",
      currentSeasonLabel: "",
      currentSubject: "数学",
      currentSubjectId: 2,
      currentSeasonId: "",
      trainingGround: {
        // 训练场
        id: 0,
        name: "训练场",
        cupStartDate: "",
        cupStartDateLabel: "",
        cupEndDate: "",
        cupEndDateLabel: "",
        scheduleId: "",
        seasonId: "",
        isTrainingGrounds: true,
      },
      otherSeasonData: [],
      subjectData: [
        {
          id: 2,
          name: "数学",
        },
        {
          id: 1,
          name: "英语",
        },
        {
          id: 3,
          name: "语文",
        },
      ],
      userName: "",
      list: [],
      filterList: [],
      rotateDeg: 135,
      minDate: new Date(2023, 3, 11),
      maxDate: new Date(2023, 4, 6),
      currentDate: new Date(),
      isCalendarShow: false,
      dataPickerValue: "",
      selectedTime: "",
      dateTime: "",
      showPicker: false,
      currentCampusId: 88,
      currentUserId: 98,
      startDate: "",
      endDate: "",
      scheduleId: "",
      seasonId: "",
      cupStartDate: "",
      cupEndDate: "",
      cupName: "",
      startDateLabel: "",
      endDateLabel: "",
      trainingData: [], // 训练场数据
      currentPage: 1,
      pageSize: 1000, //后端分页有问题，先全取出来
      defaultDate: null,
    };
  },
  created() {
    document.title = this.$route.meta.title || "松鼠杯";
  },
  mounted() {
    this.setUserInfo();
    this.initTeamInfo(); //设置了isTrainingGrounds
    if (this.isTrainingGrounds) {
      this.currentSeasonLabel = "训练场";
    } else {
      this.currentSeasonLabel = this.teamInfo.cupName.replace("松鼠杯", ""); //初始化当前的赛季标题
    }
    console.log(this.currentSeasonLabel);
    this.cupName = this.teamInfo.cupName;
    this.init();
    //TODO 初始化当前的tempFlag
    localStorage.setItem("tempFlag", this.teamInfo.title);
  },
  methods: {
    async init() {
      if (this.currentUserId) {
        await this.queryHistoryCupV3(); //只有走过这个queryHistoryCupV3方法才知道到底应不应该是训练场
        if (this.isTrainingGrounds) {
          this.getTrainingData();
        } else {
          this.queryMembers();
        }
      }
    },
    resetFilter() {
      this.finished = false;
      this.list = [];
      this.filterList = [];
      this.currentPage = 1;
    },
    initTeamInfo() {
      let teamInfo = localStorage.getItem("teamInfo");
      this.teamInfo = JSON.parse(teamInfo);
      if (
        this.teamInfo.cupStatus == 0 ||
        this.teamInfo.cupStatus == 1 ||
        this.teamInfo.cupStatus == 3
      ) {
        this.isTrainingGrounds = true; //展示训练场
      }
    },

    initDateRange() {
      /* this.startDateLabel = this.formatDate(this.startDate);
      this.endDateLabel = this.formatDate(this.endDate);*/
    },
    formatDate(date) {
      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },
    onConfirm(date) {
      const [start, end] = date;
      if (this.isTrainingGrounds) {
        // 只有训练场才做60天的限制
        const diffTime = end.getTime() - start.getTime() + 86401;
        if (diffTime > 1000 * 3600 * 24 * 60) {
          Toast("日期不能超过60天");
          return;
        }
      }
      this.resetFilter();
      this.isCalendarShow = false;
      this.startDate = formatDate(start);
      let endDate = new Date(end.getTime() + 86400 * 1000 - 1000);
      this.endDate = formatDate(endDate);
      this.startDateLabel = this.formatDate(start);
      this.endDateLabel = this.formatDate(endDate);
      if (this.isTrainingGrounds) {
        this.isSelectDate = true;
        this.getTrainingData();
      } else {
        this.queryMembers();
      }
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentUserId = userInfoId.agentUserId;
        this.currentCampusId = userInfoId.campusId;

        // currentCampusId   128，currentUserId   7631
      } else {
        Toast("找不到参赛信息");
      }
    },
    onLoad() {
      if (this.isTrainingGrounds) {
        this.getTrainingData();
      } else {
        this.queryMembers();
      }
    },
    async queryMembers() {
      if (!this.loading) {
        this.loading = true;
        let params = {
          param: {
            currentCampusId: this.currentCampusId,
            currentUserId: this.currentUserId,
            account_id: 0, //学员id
            end_date: this.endDate, //结束时间
            scheduleId: this.scheduleId,
            seasonId: this.seasonId,
            start_date: this.startDate, // 开始时间
            subject_id: this.currentSubjectId, //学科
          },
        };

        let res = await queryMembers(params);
        this.loading = false;
        if (res.code == 0) {
          res.data.forEach((item) => {
            item.isShow = false;
            item.rotateDeg = 135;
          });
          //this.currentPage = this.currentPage + 1;
          //this.list = [...this.list, ...res.data];
          if (!this.isTrainingGrounds) {
            //不是训练场，就不用再请求了
            this.finished = true;
          }
          this.list = res.data;
          this.doSearch();
        } else {
          Toast(res.message);
        }
      }
    },
    // 获取训练场数据
    /**
     *  "endTime": "2023-06-30 23:59:59",
     *         "scheduleId": "",
     *         "seasonId": "",
     *         "startTime": "2023-04-01 00:00:00",
     * @returns {Promise<void>}
     */

    async getTrainingData() {
      /*this.startDate = "2023-04-01 00:00:00";
      this.endDate = "2023-06-30 23:59:59";*/
      if (!this.loading) {
        this.loading = true;
        let params = {
          param: {
            currentCampusId: this.currentCampusId,
            currentUserId: this.currentUserId,
            accountId: 0, //学员id
            scheduleId: this.scheduleId,
            seasonId: this.seasonId,
            startTime: this.startDate, // 开始时间
            endTime: this.endDate, //结束时间
            subject: this.currentSubjectId, //学科
            page: this.currentPage,
            pageSize: this.pageSize,
            name: this.userName,
          },
        };

        let res = await getTrainingData(params);
        // 加载状态结束
        this.loading = false;
        // alert(this.loading);
        if (res.code === 0) {
          if (res.data.length === 0) {
            this.finished = true;
          }
          if (res.data.length < 1000) {
            //如果连 1000 都不到，就没必要在请求了，一定没有了
            this.finished = true;
          }
          // console.log(this.finished);
          res.data.forEach((item) => {
            item.isShow = false;
            item.rotateDeg = 135;
          });
          this.currentPage = this.currentPage + 1;
          this.list = [...this.list, ...res.data];
          // this.trainingData = res.data;
          // this.list = res.data;
          this.doSearch();
        } else {
          Toast(res.message);
        }
      }
    },
    async queryHistoryCupV3() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
        },
      };
      let res = await queryhistorycupv3(params);

      if (res.code == 0) {
        console.log(this.trainingGround,'this.trainingGround');
        this.currentSeason = this.trainingGround; //先默认设置为训练场
        this.setTrainingDefaultDate();
        this.otherSeasonData.push(this.trainingGround);
        console.log("=======");
        console.log(res.data);
        console.log("=======");
        res.data.forEach((item, index) => {
          let season = {
            id: item.cupNo,
            name: item.cupName.replace("松鼠杯", ""),
            cupStartDate: item.cupStartDate,
            cupStartDateLabel: formatMonthDate(new Date(item.cupStartDate)),
            cupEndDate: item.cupEndDate,
            cupEndDateLabel: formatMonthDate(new Date(item.cupEndDate)),
            scheduleId: item.scheduleId,
            seasonId: item.seasonId,
            isTrainingGrounds: false, // 是否是训练场
          };
          console.log('this.currentSeasonLabelxxx', this.currentSeasonLabel)
          if (season.name === this.currentSeasonLabel) {
            console.log('xxdsdsdsds')
            if (this.teamInfo.cupStatus === 2 || this.teamInfo.cupStatus === 4) {
              //只有满足这样的条件才可以设置，否则就为训练场
              this.defaultDate = null;
              this.currentSeason = season;
              console.log('season', season);
              this.scheduleId = this.currentSeason.scheduleId;
              this.seasonId = this.currentSeason.seasonId;
              let cupStartDate = this.currentSeason.cupStartDate;
              console.log('cupStartDate--', cupStartDate);
              let cupEndDate = this.currentSeason.cupEndDate;
              this.minDate = new Date(cupStartDate);
              this.startDate = formatDate(this.minDate);
              console.log('this.startDate---', this.startDate);
              let maxDate = new Date(cupEndDate);
              let today = new Date();
              if (maxDate.getTime() > today.getTime()) {
                maxDate = today;
              }
              this.maxDate = maxDate;
              this.endDate = formatDate(this.maxDate);
            } else {
              //否则就还是设置回训练场才可以
              this.currentSeasonLabel = "训练场";
              this.isTrainingGrounds = true;
            }
          }
          this.otherSeasonData.push(season);
        });
      } else {
        Toast(res.message);
      }
    },
    showInfo(index) {
      let item = this.filterList[index];
      item.isShowAll = !item.isShowAll;
      if (item.isShowAll) {
        item.rotateDeg = -45;
      } else {
        item.rotateDeg = 135;
      }
      this.$set(this.filterList, index, item);
    },

    handleDateSelection() {
      if (this.isTrainingGrounds) {
        this.isSelectDate = true;
      } else {
        this.isSelectDate = false;
      }
      this.isCalendarShow = true;
    },
    formatter(type, value) {
      if (type === "year") {
        return value + "年";
      } else if (type === "month") {
        return value + "月";
      } else if (type === "day") {
        return value + "日";
      }
      return value;
    },
    getUserName(data) {
      this.userName = data.userName.trim();
    },
    doSearch() {
      console.log(this.userName);
      let list = this.list.filter((item) => {
        if (
          item.real_name.indexOf(this.userName) > -1 ||
          item.uname.indexOf(this.userName) > -1
        ) {
          // console.log(111);
          return item;
        }
      });
      this.filterList = list;
    },
    // 设置训练场默认日期
    setTrainingDefaultDate() {
      this.minDate = new Date(2023, 2, 11);
      this.maxDate = new Date();
      const start = new Date();
      start.setTime(
        new Date(start.setHours(0, 0, 0, 0)).getTime() - 3600 * 1000 * 24 * 6
      );
      this.defaultDate = [start, new Date()];
    },
    seasonChange(data) {
      this.isTrainingGrounds = data.item.isTrainingGrounds;
      this.currentSeason = data.item;
      this.currentSeasonLabel = data.item.name;
      console.log(data.item.name);
      //TODO 需要根据赛季进行动态增加修改
      console.log(this.currentSeasonLabel);
      if (this.currentSeasonLabel == "2023春季赛") {
        localStorage.setItem("tempFlag", "2023_spring");
      } else if (this.currentSeasonLabel == "2023夏季赛") {
        localStorage.setItem("tempFlag", "2023_summer");
      } else if (this.currentSeasonLabel == "训练场") {
        localStorage.setItem("tempFlag", "2023_summer");
      }
      console.log(localStorage.getItem("tempFlag"));
      this.resetFilter();

      if (this.isTrainingGrounds) {
        this.setTrainingDefaultDate();
        this.startDate = "";
        this.endDate = "";
        this.getTrainingData();
      } else {
        this.defaultDate = null;
        this.defaultDate = [null, new Date()];
        let minDate = new Date(data.item.cupStartDate.replaceAll("-", "/"));
        let maxDate = new Date(data.item.cupEndDate.replaceAll("-", "/"));

        this.currentUserId = data.item.id;
        this.scheduleId = data.item.scheduleId;
        this.seasonId = data.item.seasonId;
        if (data.item.name == '2023秋季赛') {
          this.startDate = '2023-10-14 00:00:00';
          this.endDate = '2023-11-25 23:59:59';
        } else {
          this.startDate = formatDate(
            new Date(data.item.cupStartDate.replaceAll("-", "/"))
          );

          this.endDate = formatDate(
            new Date(data.item.cupEndDate.replaceAll("-", "/") + " 23:59:59")
          );
        }
        
        this.minDate = minDate;
        this.maxDate = maxDate;

        this.queryMembers();
      }
    },
    subjectChange(data) {
      this.resetFilter();
      this.currentSubject = data.item.name;
      this.currentSubjectId = data.item.id;

      if (this.isTrainingGrounds) {
        this.getTrainingData();
      } else {
        this.queryMembers();
      }
    },
  // 去往其他赛季
    toRests(){
        this.$router.push('/winterGame/rests')
    },
    // 查看详情
    viewMemberDetail(studentData) {
      const { account_id } = studentData;
      const scheduleId = this.currentSeason.scheduleId || 0;
      const seasonId = this.currentSeason.seasonId || undefined;
      this.$router.push({
        path: `/winterGame/memberDetail/${account_id}/${this.currentSubject}/${this.currentSeason.name}/${seasonId}/${scheduleId}`,
      });
    },
  },
};
</script>
<style lang="less">
.van-calendar__day--end,
.van-calendar__day--start,
.van-calendar__day--start-end,
.van-calendar__day--multiple-middle,
.van-calendar__day--multiple-selected {
  background: #58abf6;
}
.van-button--danger {
  background: #58abf6;
  border: 2px solid #58abf6;
}
.van-calendar__day--middle {
  color: #58abf6;
}
</style>

<style lang="less" scoped>
html {
  background: #f6f9fd;
}
* {
  margin: 0;
  padding: 0;
}
.studentAchievement {
  background: #f6f9fd;
  min-height: 100vh;
  padding-bottom: 10px;
  header {
    height: 334px;
    padding: 32px;
    box-sizing: border-box;
    background: #ffffff;
    margin-bottom: 16px;
    img.calendar {
      width: 32px;
    }
    & > div {
      display: flex;
      justify-content: center;

      &:last-child {
        display: flex;
        justify-content: flex-end;
      }
      .main-title {
        margin-left: 120px;
        flex: 1;
      }
      .otherSeason {
        margin-right: 20px;
        font-size: 28px;
        color: #68707D;
        // position: absolute;
        // right: 30px;
      }
      &.inputBoxWrapper {
        margin-top: 24px;
        padding-bottom: 24px;
        border-bottom: 2px solid #e6e6e6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .honorRoll {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #58abf6;
          line-height: 40px;
          margin-left: 24px;
        }
      }

      &:last-child {
        display: flex;
        align-items: center;
        margin-top: 26px;
        color: #68707d;
        font-size: 28px;
        label {
          display: flex;
          align-items: center;
          font-size: 28px;
          margin-right: 52px;
          img {
            width: 32px;
            height: 32px;
            margin-left: 10px;
          }
        }
      }
    }

    h3 {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #323232;
      line-height: 44px;
      text-align: center;
    }

    p {
      height: 40px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #68707d;
      line-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        margin-left: 10px;
        align-items: center;
        width: 42px;
      }
    }
  }
  > section {
    .list {
      height: 80vh;
      overflow: auto;
      .item {
        width: 718px;
        margin: auto;
        position: relative;
        padding: 32px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 16px;
        margin-bottom: 16px;

        .title {
          display: flex;
          align-items: center;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 34px;
          margin-bottom: 32px;

          h3 {
            height: 44px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #323232;
            line-height: 44px;
            margin-right: 16px;
          }

          .more {
            font-size: 28px;
            color: #58abf6;
            margin-left: auto;
          }
        }

        main {
          display: flex;

          table {
            table-layout: fixed;
            width: 100%;

            tr {
              &:first-child {
                td {
                  &:first-child {
                    div {
                      position: relative;
                      // left: -15px;
                      // padding-left: 10px;
                      dl:first-child {
                        border-radius: 16px 0 0 16px;
                        padding: 16px;
                        background: #f6f9fd;
                        dt {
                          color: #58abf6;
                        }
                      }
                      dl:nth-child(2) {
                        border-radius: 0 16px 16px 0;
                        padding: 16px;
                        background: #f6f9fd;
                        dt {
                          color: #58abf6;
                        }
                      }
                      dl:last-child {
                        padding: 16px;
                      }
                    }
                  }

                  // div {
                  //   margin-bottom: 32px;
                  // }
                }
              }

              td {
                div {
                  display: flex;
                  justify-content: space-around;
                  padding: 16px 8px;

                  dl {
                    text-align: center;

                    // &:last-child {
                    //   flex-grow: 1;
                    //   margin-left: 40px;
                    // }
                    flex: 1;
                    dt {
                      height: 40px;
                      font-size: 28px;
                      font-family: PingFangSC-Medium, PingFang SC;
                      font-weight: 500;
                      color: #323232;
                      line-height: 40px;
                      margin-bottom: 16px;
                    }

                    dd {
                      height: 40px;
                      font-size: 28px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #68707d;
                      line-height: 40px;
                    }
                  }
                }
              }
            }
          }

          .trainingGrounds {
            div {
              &:last-child {
                margin-top: 32px;
              }

              span {
                display: block;
                width: 176px;
                margin-bottom: 8px;
                height: 40px;
                background: #f6f9fd;
                border-radius: 20px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #58abf6;
                line-height: 40px;
                text-align: center;
              }

              div {
                display: flex;

                dl {
                  margin-right: 72px;

                  dt {
                    height: 40px;
                    font-size: 28px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #323232;
                    line-height: 40px;
                    margin-bottom: 16px;
                  }

                  dd {
                    height: 40px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #68707d;
                    line-height: 40px;
                  }
                }
              }
            }
          }

          section {
            flex-grow: 1;

            & > div {
              display: flex;
              justify-content: space-between;

              &:first-child {
                margin-bottom: 48px;
              }

              dl {
                margin-right: 46px;

                &:last-child {
                  margin-right: 0;
                }
              }
            }
          }
        }

        .arrow {
          position: absolute;
          top: 90px;
          right: 16px;

          &.trainingGroundsArr {
            top: 150px;
          }
        }
      }
    }
    .emptyData {
      margin-top: 186px;
    }
  }
}
.loading-container {
  width: 100%;
  height: 45vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.textSty{
  white-space: nowrap;
}
</style>
